<template>
    <div class="herobanner-controller">
        <component v-bind="heroBannerProps" :is="heroType"></component>
    </div>
</template>

<script>
import { heroBannerLogic } from '@/mixins';
import { HERO_COMPONENTS } from './HeroBanner.constants';
import HeroBannerAlpha from '@organisms/HeroBanners/HeroBannerAlpha/HeroBannerAlpha.vue';
import HeroBannerBeta from '@organisms/HeroBanners/HeroBannerBeta/HeroBannerBeta.vue';

export default {
    name: 'HeroBannerController',
    components: {
        HeroBannerAlpha,
        HeroBannerBeta,
    },
    mixins: [heroBannerLogic],
    props: {
        category: {
            type: Object,
            default: () => ({}),
        },
        isLoaded: {
            type: Boolean,
            default: false,
        },
        heroType: {
            type: String,
            default: HERO_COMPONENTS.HeroBannerAlpha,
        },
    },
};
</script>

<style lang="scss" scoped>
@import '@/sass/mixins';
.herobanner-controller {
    width: inherit;
    min-height: 80px;
}
</style>
